/** @format */

import React from 'react'
import localize from '../../../../../../../Global/Localize'
import { formatDate } from '../../../../../../../Helpers/formatters'

const IndividualParticulars = ({ customer }) => {
  return (
    <>
      <div className="row g-3">
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('individualType')}
          </label>
          <input
            value={customer?.individualTypeDescription}
            disabled
            className="form-control"
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('nationality')}
          </label>
          <input
            className="form-control"
            value={customer?.individualNationalityDescription}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('salutation')}
          </label>
          <input
            className="form-control"
            value={customer?.individualSalutationDescription}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">{localize('gender')}</label>
          <input
            className="form-control"
            value={customer?.individualGenderDescription}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('firstName')}
          </label>
          <input
            type="text"
            className="form-control"
            value={customer?.individualFirstName}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('otherNames')}
          </label>
          <input
            type="text"
            className="form-control"
            value={customer?.individualLastName}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('birthDate')}
          </label>
          <input
            type="text"
            className="form-control"
            value={formatDate(customer?.individualBirthDate, true)}
            disabled
          />
        </div>

        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('educationLevel')}
          </label>
          <input
            type="text"
            className="form-control"
            value={customer?.individualEducationLevelDescription}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('identityCardType')}
          </label>
          <input
            value={customer?.individualIdentityCardTypeDescription}
            className="form-control"
            type="text"
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('identityCardNumber')}
          </label>
          <input
            type="text"
            className="form-control"
            disabled
            value={customer?.individualIdentityCardNumber}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('identityCardSerialNumber')}
          </label>
          <input
            type="text"
            className="form-control"
            value={customer?.individualIdentityCardSerialNumber}
            disabled
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('pinNumber')}
          </label>
          <input
            type="text"
            className="form-control"
            disabled
            value={customer?.personalIdentificationNumber}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('employmentSector')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.employmentSectorDescription}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('employmentTerms')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.individualEmploymentTermsOfServiceDescription}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('employmentDesignation')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.individualEmploymentDesignation}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('employmentDate')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={formatDate(customer?.individualEmploymentDate, true)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('maritalStatus')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.individualMaritalStatusDescription}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('disabilityType')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.individualDisabilityTypeDescription}
          />
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <label className="col-4 text-capitalize">
            {localize('hudumaNumber')}
          </label>
          <input
            disabled
            type="text"
            className="form-control"
            value={customer?.individualHudumaNumber}
          />
        </div>
      </div>
    </>
  )
}

export default IndividualParticulars
